/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VaultSnapshotCount } from '../models/VaultSnapshotCount';

/**
* Snapshot distribution data for a specific month
*/
export class MonthlySnapshotData {
  /**
  * Month number (1-12)
  */
  'month': number;
  /**
  * Total number of snapshots for this month
  */
  'totalCount': number;
  /**
  * Total number of cluster snapshots for this month (only present for Aurora Global Database clusters)
  */
  'clusterCount'?: number;
  /**
  * Snapshot counts grouped by vault for this month
  */
  'snapshotsPerVault': Array<VaultSnapshotCount>;
  /**
  * Number of non-Eon snapshots (cloud provider snapshots not managed by Eon) for this month
  */
  'nonEonSnapshotCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "month",
      "baseName": "month",
      "type": "number",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "clusterCount",
      "baseName": "clusterCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "snapshotsPerVault",
      "baseName": "snapshotsPerVault",
      "type": "Array<VaultSnapshotCount>",
      "format": ""
    },
    {
      "name": "nonEonSnapshotCount",
      "baseName": "nonEonSnapshotCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MonthlySnapshotData.attributeTypeMap;
  }

  public constructor() {
  }
}

